import {
	Box,
	Center,
	Container,
	Flex,
	Heading,
	IconButton,
	SimpleGrid,
	Spinner,
	Text,
} from '@chakra-ui/react'
import LeftSidebarFilters from '../components/LeftSidebarFilters'
import BusinessCard from '../components/BusinessCard'
import PageSearchForm from '../components/PageSearchForm'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { queryParamsToObject } from '../helpers/utils'
import { fetchBusinessList, toggleBusinessFilter } from '../redux'
import { FiFilter } from 'react-icons/fi'
import InfiniteLoader from 'react-infinite-loader'

const Search = () => {
	const [params, setParams] = useState(null)
	const business = useSelector((state) => state.business)
	const dispatch = useDispatch()
	const { hasMore, setHasMore } = useState(true)
	const [page, setPage] = useState(1)

	useEffect(() => {
		const qParams = window.location.search
			? queryParamsToObject(window.location.search.substring(1))
			: {}
		setParams(qParams)
		dispatch(fetchBusinessList({ ...qParams, limit: 12 }, false))
	}, [dispatch])

	const fetchMoreData = () => {
		if (business.businessList.length >= business.pagination.totalItem) {
			setHasMore(false)
			return
		}

		let pageNo = page
		pageNo = pageNo + 1
		setPage(page + 1)

		dispatch(fetchBusinessList({ ...params, page: pageNo, limit: 12 }, true))
	}

	return (
		<>
			<Box
				py={'8'}
				borderBottomWidth={'1px'}
				borderBottomStyle={'solid'}
				borderColor={'gray.300'}
			>
				<Container maxW={'container.xl'}>
					<PageSearchForm qParamsObj={params} />
				</Container>
			</Box>
			<Container maxW={'container.xl'}>
				<Flex>
					<LeftSidebarFilters qParamsObj={params} />

					<Box
						borderLeftWidth={[0, 0, 0, '1px']}
						borderLeftStyle={'solid'}
						borderLeftColor={'gray.300'}
						w={['100%', '100%', '100%', 'calc(100% - 320px)']}
						ps={[0, 0, 0, '6']}
						pb={'6'}
						pt={5}
					>
						<Box>
							<Flex justify={'space-between'} mb={'4'} alignItems={'center'}>
								<Heading fontSize={'1.3rem'}>All Result</Heading>

								<Box display={['block', 'block', 'block', 'none']}>
									<IconButton
										onClick={() => dispatch(toggleBusinessFilter())}
										icon={<FiFilter />}
									/>
								</Box>
							</Flex>

							<SimpleGrid gap={[4, 5, 6, 6]} columns={[1, 1, 2, 2]}>
								{business.businessList.map((business, index) => (
									<BusinessCard key={index} data={business} />
								))}
							</SimpleGrid>

							{!business.businessList.length > 0 && !business.isLoading && (
								<Box>
									<Text textAlign={'center'}>No business found</Text>
								</Box>
							)}

							{business.isLoading && (
								<Center h={'100px'} mt={'30px'}>
									<Box>
										<Spinner
											thickness="4px"
											speed="0.65s"
											emptyColor="gray.200"
											color="brand.500"
											size="xl"
										/>
										<Text textAlign={'center'}>Loading...</Text>
									</Box>
								</Center>
							)}
							{/* {!hasMore &&
								!business.isLoading &&
								business.businessList.length > 0 && (
									<Text textAlign={'center'}>No More Data.</Text>
								)} */}
						</Box>
					</Box>
				</Flex>
			</Container>
			<InfiniteLoader onVisited={() => fetchMoreData()} />
		</>
	)
}

export default Search
